import React, { useRef } from "react";
import client from "@culturehq/client";
import { useFetch } from "app/hooks";
import { Loader } from "@culturehq/components";

import ErrorBoundary from "components/common/ErrorBoundary";
import SuggestedInterests from "components/community/panels/SuggestedInterests";
import BuildConnections from "components/dashboard/BuildConnections";
import Commonalities from "components/person/Commonalities";
import SimilarPeople from "components/person/SimilarPeople";
import ProfileStories from "./ProfileStories";

const StoriesCreated = ({ user, isProfile }) => {
  const { fetching, json: { connections = [] } } = useFetch(client.listProfileSuggestedConnections);
  const feedRef = useRef();

  return (
    <div className="row User--Feed" ref={feedRef}>
      <div className="Central--column Feed--column Stories col-xs-12 col-sm-8">
        <ErrorBoundary>
          <ProfileStories
            feedRef={feedRef}
            isProfile={isProfile}
            user={user}
          />
        </ErrorBoundary>
      </div>
      <div className="Feed--right hidden-xs col-sm-4">
        <Loader loading={fetching}>
          {
            (isProfile && connections.length > 0)
              ? (
                <>
                  <BuildConnections connections={connections} />
                  <div className="Person--Suggested-Interests">
                    <SuggestedInterests />
                  </div>
                </>
              ) : (
                <>
                  {!isProfile && (<Commonalities user={user} />)}
                  <SimilarPeople isProfile={isProfile} user={user} />
                </>
              )
          }
        </Loader>
      </div>
    </div>
  );
};

export default StoriesCreated;
